import { types } from '../page/Chapter'

export const FourthData: types = [
  {
    id: 1,
    date: '',
    problem: '',
    state: '',
    result: [''],
  },
]
